export const PREFIX_ROUTE = 'fe-route';

export const CS_PHONE_NUMBER = '+201092228643';
